import React from "react";
import Seo from "../components/Seo";
import Loading from "../components/Loading";
import {Link} from "react-router-dom";
import "../css/Documentation.css";
import {BrokerBenchmark, parseBrokerResult} from "../components/BrokerBenchmark";
import fanOutUrl from "../xmq_test_results/Fan-Out.txt";

export default class XMQ_tests_fanout extends React.Component
{
    state = {servers: null, error: null};

    componentDidMount()
    {
        fetch(fanOutUrl)
            .then((r) => r.text())
            .then((text) => this.setState({servers: parseBrokerResult(text)}))
            .catch((err) => this.setState({error: String(err)}));
    }

    render()
    {
        const {servers, error} = this.state;
        return <div key="tests-fanout" className="XMQ" style={{textAlign: "left", padding: 8}}>
            <Seo title="MQTT Performance Tests — Fan-Out"
                 description="MQTT fan-out benchmark: five publishers broadcast QoS 1 messages to 1,000 subscribers, measuring delivery throughput and latency."
                 keywords="MQTT performance tests, fast MQTT server, MQTT benchmark, XMQ"
                 path="/xmq_tests_fanout"/>
            <h1>MQTT Performance Tests: Fan-Out</h1>
            <h3>Fan-Out: Broadcast Delivery</h3>

            <p>
                Models a broadcast workload: five publishers produce 250 messages/second in
                total, and 1,000 subscribers receive each matching message. That is 250,000
                deliveries/second at QoS&nbsp;1. See the
                {" "}<Link to="/xmq_tests_environment">Test Environment</Link> page for hardware
                and test method.
            </p>

            <p>
                XMQ 1.0.2 and FlashMQ 1.27.2 were re-measured on 2 November 2026 on the same
                c5n.4xlarge host (16 vCPU, 40 GB) as the other brokers here. Percentiles are
                shown where the run recorded them; a dash means its result file has no percentile
                section.
            </p>

            {error && <p>Failed to load test results: {error}</p>}
            {!servers && !error && <Loading text="Loading results…"/>}

            <BrokerBenchmark servers={servers} targetRate={250000}/>

        </div>;
    }
}
